import React from 'react';
import { Helmet } from 'react-helmet';
import Topnavigation from '../Layouts/Topnavigation';
import Sidenavigation from '../Layouts/Sidenavigation';
import Content from '../../CommonFolders/Miscellaneous-Refund-Report/Content';

export default function ManagerMiscellaneousRefundReport(){
    return (
        <div className="ms-body ms-aside-left-open ms-primary-theme ">
            {/* title */}
            <Helmet>
                <title>Miscellaneous Refund Report</title>
            </Helmet>

            {/* sidebar start  */}
            <Sidenavigation />
            {/* sidebar end */}

            <main className="body-content">

                {/* Topnavigation start */}
                <Topnavigation />
                {/* Topnavigation end  */}

                {/* page content start  */}
                <Content Page='Manager' />
                {/* page content end  */}

            </main>

        </div>
    )
}